import Container from "@client/content/Containers/container";
import { getContainerProps, getRootContainerProps } from "@client/content/lib/helper";
import { type ModuleApiInfo } from "@client/content/selectors";
import { type RootContainerProps } from "@client/content/types";
import { type WithIsEditMode } from "@client/types";
import { useI18n } from "@common/hooks/i18n";
import * as React from "react";
import Entry from "./Entry/container";
import Survey from "./Survey/container";

import "./style.less";

export type MapProps = RootContainerProps &
  WithIsEditMode & {
    apiInfo: ModuleApiInfo;
    formId: string | null;
    isSurveyPage: boolean;
    mustEnter: boolean;
  };

export type ActionProps = {};

type Props = ActionProps & MapProps;
export default (props: Props) => {
  const i18n = useI18n();

  return (
    <Container className="wsc_content_form" {...getContainerProps(props)}>
      {props.formId ? (
        props.mustEnter ? (
          <Entry {...getRootContainerProps(props)} formId={props.formId} />
        ) : (
          <Survey {...getRootContainerProps(props)} formId={props.formId} />
        )
      ) : props.isEditMode ? (
        props.isSurveyPage ? (
          i18n.infoUseFormLink
        ) : (
          i18n.infoSelectForm
        )
      ) : null}
    </Container>
  );
};
